"use client";

import createSvgIcon from "./utils/createSvgIcon.js";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon(/*#__PURE__*/_jsx("path", {
  d: "M5 1v22h14V1zm12 17H7V6h10zm-1-6h-3V8h-2v4H8l4 4z"
}), 'SecurityUpdateSharp');